import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'jd-library';
import styles from './commonStyle.scss';
import { toggleSpecificationSlider } from '../../actions/productSpecification';

const SpecificationModal = props => {
    const dispatch = useDispatch();
    return (
        <Modal
            settings={{
                modalId: 'ai-modals',
                variant: 'action',
                class: styles["ai-modals"],
            }}
            backdropStatic
            onHidden={props.onHidden}
            onVisible = {() => {props.recordImpression('specReqModal')}}
        >
            <Modal.CloseIcon />
            <Modal.Header className={styles['modal-heading']}>Five Specifications Required</Modal.Header>
            <Modal.Body className={styles['modal-body']}>Please enter at least 5 specifications to generate a meaningfull description</Modal.Body>
            <Modal.CenterButton
                className={styles['cntr-btn']}
                onClick={() => {
                    props.recordImpression('addSpecBtn');
                    window.history.back();
                    setTimeout(() => {
                        dispatch(toggleSpecificationSlider({specSlider: true,aiFlow: true}));
                    }, 500);
                    }}
                >
                    Add Specifications
                </Modal.CenterButton>
            </Modal>
    )
}

export default SpecificationModal;